<template>
  <table class="table">
    <tr>
      <th>
        {{$t('permissionTable.resourceColumn')}}
      </th>
      <th class="text-center">
        {{$t('permissionTable.readColumn')}}
      </th>
      <th class="text-center">
        {{$t('permissionTable.createColumn')}}
      </th>
      <th class="text-center">
        {{$t('permissionTable.updateColumn')}}
      </th>
      <th class="text-center">
        {{$t('permissionTable.deleteColumn')}}
      </th>
    </tr>
    <tr v-for="item in permissionsArray" :key="item.resource">
      <td>{{item.resource}}</td>
      <td class="text-center">{{item.read | bool}}</td>
      <td class="text-center">{{item.create | bool}}</td>
      <td class="text-center">{{item.update| bool}}</td>
      <td class="text-center">{{item.delete| bool}}</td>
    </tr>
  </table>
</template>

<script>
  export default {
    name: "PermissionsTable",
    props: {
      permissions: {
        type: [Object, Array], // Sometimes permissions can be as object(when comes from user), sometimes as array (when comes from role).
        required: true,
      },
      roles: {
        type: Array,
        required: true,
      }
    },
    computed: {
      permissionsArray: function () {
        const details = this.permissions

        if (this.roles && this.roles[0] == 'admin') {
          return [{
            resource: "*",
            read: true,
            create: true,
            update: true,
            delete: true,
          }]
        }

        if (Array.isArray(details)) {
          return this.fromArray(details)
        } else {
          return this.fromObject(details)
        }
      }
    },
    methods: {
      fromObject: function (details) {
        let out = []
        for (const prop in details) {
          const perms = details[prop]
          let p = {
            resource: prop,
            read: perms.includes("read"),
            create: perms.includes("create"),
            update: perms.includes("update"),
            delete: perms.includes("delete"),
          }

          out.push(p)
        }
        return out
      },
      fromArray: function (details) {
        let tmp = {}
        let out = []
        details.forEach(function (entry) {
          let p = tmp[entry.resource]
          if (!p) {
            p = {
              resource: entry.resource,
              read: false,
              create: false,
              update: false,
              delete: false,
            }
            tmp[entry.resource] = p
            out.push(p)
          }

          switch (entry.action) {
            case 'read':
              p.read = true;
              break
            case 'create':
              p.create = true;
              break
            case 'update':
              p.update = true;
              break
            case 'delete':
              p.delete = true;
              break
          }
        });

        return out
      }
    }
  }
</script>

<style scoped>
  .el-table th {
    background-color: transparent !important;
  }
</style>
